exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.description[data-v-bcd89628] {\n    padding: 5px 10px;\n}\n", ""]);

